import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { CallToActionButton } from '@finn-no/troika-react-buttons';

import { actions as filterActions } from '../../../state/filterActions';
import { fetchResults } from '../../../state/resultActions';

import { ApiQueryParams, PaleState } from '../../../interfaces';
import {
    checkboxToFilterData,
    checkboxTreeToFilterData,
    datesToFilterData,
    FilterData,
    ResetCurrentFilterPayload,
    sliderToFilterData,
    stringToFilterData,
} from './FilterToFilterData';

import displayValues from '../../../resources/displayValues.json';

export interface CurrentFiltersProps {
    filterList: FilterData[];
    resetFilter: (payload: ResetCurrentFilterPayload) => void;
    triggerFetch: (queryParams?: ApiQueryParams) => void;
}

const originAirportNames = displayValues.originAirports.reduce(
    (acc: Record<string, string>, cur) => ({ ...acc, [cur.value]: cur.text }),
    {}
);

export const CurrentFilters: React.FC<CurrentFiltersProps> = ({
    filterList,
    resetFilter,
    triggerFetch,
}): ReactElement<CurrentFiltersProps> => (
    <div className="u-m-ph16">
        {filterList.map((filter) => (
            <CallToActionButton
                small
                className="max-width-100 u-mh4 u-mb4"
                key={filter.id}
                data-testid={`currentFilters-${filter.id}`}
                onClick={(): void => {
                    resetFilter({ location: filter.location, filterType: filter.filterType, value: filter.value });
                    triggerFetch();
                }}>
                <div className="flex flex-row">
                    <div className="u-truncate">{filter.displayName}</div>
                    <i className="image--cross-white" />
                </div>
            </CallToActionButton>
        ))}
    </div>
);

const mapStateToProps = ({ filters }: PaleState): { filterList: FilterData[] } => ({
    filterList: [
        ...stringToFilterData(filters.origin, (a) => `Avreise fra ${originAirportNames[a]}`, 'origin'),
        ...datesToFilterData(filters.ignoredFilters, filters.departureDate, filters.returnDate, filters.travelMonths, filters.duration),
        ...checkboxTreeToFilterData(filters.destinations.tree),
        ...sliderToFilterData(filters.priceRange, 'Pris', 'kr', 'priceRange'),
        ...checkboxToFilterData(filters.rating, (a) => `${a} - stjerner`, 'rating'),
        ...sliderToFilterData(filters.distanceToBeach, 'Avstand strand', 'm', 'distanceToBeach'),
        ...sliderToFilterData(filters.distanceToCity, 'Avstand sentrum', 'm', 'distanceToCity'),
        ...checkboxToFilterData(filters.meals, (a) => (displayValues.amenities.meals as Record<string, string>)[a], 'meals'),
        ...checkboxToFilterData(filters.facilities, (a) => (displayValues.amenities.facilities as Record<string, string>)[a], 'facilities'),
        ...checkboxToFilterData(filters.activities, (a) => (displayValues.amenities.activities as Record<string, string>)[a], 'activities'),
        ...stringToFilterData(filters.keywords, (a) => `Keywords ${a}`, 'keywords'),
        ...checkboxToFilterData(filters.suppliers, (a) => `Tilbyder: ${a}`, 'suppliers'),
    ],
});

const mapDispatchToProps = { resetFilter: filterActions.filterResetSpecific, triggerFetch: fetchResults };

export default connect(mapStateToProps, mapDispatchToProps)(CurrentFilters);
